import React from "react";
import { BreadCrumbBox, Grid, Section } from "../../core";
import ProgramHistory from "../../components/ProgramHistory";

const ProgramHistoryCompo = () => {
  return (
    <Grid>
      <BreadCrumbBox tittle="Program History" />
      <Section padding="0px 30px">
        {/* <FilterWraper > */}
        <ProgramHistory />
        {/* </FilterWraper> */}
      </Section>
    </Grid>
  );
};

export default ProgramHistoryCompo;
